import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function PageHeader({ title, back, action, subtitle }) {
  return (
    <div className="mb-6 flex items-start justify-between gap-3 fade-up">
      <div className="flex items-start gap-2">
        {back && (
          <Link to={back} data-testid="page-back-btn" className="-ml-2 mt-0.5 rounded-full p-2 text-slate-600 hover:bg-slate-100">
            <ChevronLeft className="h-5 w-5" />
          </Link>
        )}
        <div>
          <h1 className="text-2xl font-extrabold capitalize-first text-slate-900">{title}</h1>
          {subtitle && <p className="mt-0.5 text-sm text-slate-500">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}

export function Empty({ icon: Icon, text, children }) {
  return (
    <div className="card flex flex-col items-center gap-3 px-6 py-12 text-center text-slate-500" data-testid="empty-state">
      {Icon && <Icon className="h-9 w-9 text-slate-300" />}
      <p>{text}</p>
      {children}
    </div>
  );
}

export function Section({ title, children, action }) {
  return (
    <section className="mb-7 fade-up">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="eyebrow">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}

export function Loading() {
  return (
    <div className="space-y-3" data-testid="loading">
      {[0, 1, 2].map((i) => <div key={i} className="h-20 animate-pulse rounded-2xl bg-slate-200/60" />)}
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="label">{label}</span>
      {children}
    </label>
  );
}

export function Segmented({ options, value, onChange, testid }) {
  return (
    <div className="grid gap-1 rounded-xl bg-slate-100 p-1" style={{ gridTemplateColumns: `repeat(${options.length}, 1fr)` }}>
      {options.map(([k, l]) => (
        <button key={k} onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
          className={`min-h-[42px] rounded-lg text-sm font-semibold transition-colors ${value === k ? "bg-white text-teal-800 shadow-sm" : "text-slate-600"}`}>{l}</button>
      ))}
    </div>
  );
}

export function MonthNav({ month, setMonth, label }) {
  const shift = (n) => {
    const [y, m] = month.split("-").map(Number);
    const d = new Date(y, m - 1 + n, 1);
    setMonth(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
  };
  return (
    <div className="mb-4 flex items-center justify-between">
      <button className="rounded-full p-3 hover:bg-slate-100" onClick={() => shift(-1)} data-testid="month-prev-btn" aria-label="Mois précédent"><ChevronLeft className="h-5 w-5" /></button>
      <span className="font-display text-lg font-extrabold capitalize" data-testid="month-label">{label}</span>
      <button className="rotate-180 rounded-full p-3 hover:bg-slate-100" onClick={() => shift(1)} data-testid="month-next-btn" aria-label="Mois suivant"><ChevronLeft className="h-5 w-5" /></button>
    </div>
  );
}
